import { Role, Permissions } from "./permissions";

// 权限映射表
export const rolePermissionsMap: Record<Role, Permissions[]> = {
  [Role.Admin]: [],
  [Role.Market]: [],
  [Role.Service]: [],
  [Role.ServiceLead]: [

  ],
};
